import { z } from 'zod'
import { dateValueSchema } from '~library/models'

/** 航段資料 Schema */
export const flightSegmentSchema = z.object({
  /** 訂位代號 */
  pnr: z.string(),
  /** 航空公司 */
  airline: z.string(),
  /** 機票號碼 */
  ticketNumber: z.string(),
  /** 開票日期 */
  issueTime: dateValueSchema,
  /** 班機號碼 */
  flightNumber: z.string(),
  /** 航段 */
  flightSegment: z.array(z.string()),
  /** 出發日期 */
  departureTime: dateValueSchema,
  /** 艙等 */
  rbd: z.string(),
  /** 可否兌換禮遇 */
  allowExchange: z.boolean(),
  /** 可使用的數量 */
  quantity: z.union([z.number(), z.null()]),
  /** 同一段行程同數字 */
  stowner: z.string(),
  /** 已使用禮遇數量 - 超額行李 */
  pdbgQuantity: z.number().nullable()
})

/** 航段資料 */
export interface FlightSegment extends z.infer<typeof flightSegmentSchema> {}
